var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
  { Select__blue: _vm.colour === 'blue' },
  { Select__white: _vm.colour === 'white' },
  _vm.$style.select
]},[_c('multiselect',{attrs:{"options":_vm.options,"searchable":false,"show-labels":false,"trackBy":_vm.trackBy,"label":_vm.label,"placeholder":_vm.placeholder,"allow-empty":false,"index":_vm.index},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }